export default __webpack_public_path__ + "static/media/streak-365.530fdc52.png";